import { z } from 'zod';

export const SECCION_COBRADOR = ['hoy', 'pendientes', 'visitas'] as const;
export type SeccionCobrador = (typeof SECCION_COBRADOR)[number];

export const QueryCobradorClientesDtoSchema = z.object({
  seccion: z.enum(SECCION_COBRADOR),
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export type QueryCobradorClientesDto = z.infer<typeof QueryCobradorClientesDtoSchema>;
